import type { JSXChild, JSXProps } from 'engine/index';

export function Button(props: JSXProps, children: JSXChild[]) {
	return (
		<button {...props} class="rounded-md bg-theme-600 p-4 text-theme-50">
			{children}
		</button>
	);
}
